import { z } from "zod";

export const clientSchema = z.object({
  name: z
    .string()
    .min(1, "Client name is required")
    .max(255, "Client name must be less than 255 characters"),
  website: z
    .string()
    .max(500, "Website link must be less than 500 characters")
    .refine(
      (val) => {
        if (!val || val === "") return true;
        try {
          new URL(val);
          return true;
        } catch {
          return false;
        }
      },
      { message: "Please enter a valid URL (e.g., https://example.com)" }
    )
    .optional()
    .or(z.literal("")),
  address: z
    .string()
    .max(500, "Address must be less than 500 characters")
    .optional()
    .or(z.literal(""))
});

export type ClientFormData = z.infer<typeof clientSchema>;